import RichText from './RichText';

import styles from './RichText.module.scss';

export { type RichTextProps } from './RichText';

export const richTextStyles = styles;

export default RichText;
